var map = {
	"./about/About.vue": [
		"ffdb",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-ac070b3c"
	],
	"./contact/Contact.vue": [
		"502a",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-2a1b9570"
	],
	"./decennial/Decennial.vue": [
		"d7a5",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-49dc0290"
	],
	"./home/Home.vue": [
		"5afa",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-cfa73002"
	],
	"./medium/Medium.vue": [
		"92dd",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-10c21fb4"
	],
	"./medium/MediumDetail.vue": [
		"eb7e",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-05b5509a"
	],
	"./medium/SubView.vue": [
		"9ffd",
		"chunk-764eac5c"
	],
	"./products/Product.vue": [
		"a625",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-66474e1d"
	],
	"./products/SubView.vue": [
		"b20b",
		"chunk-23577468"
	],
	"./products/componets/RelatedProduct.vue": [
		"f845",
		"chunk-557be3e8"
	],
	"./products/details/Autoflak.vue": [
		"bca6",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-6ef3dbc4"
	],
	"./products/details/Autopipeline.vue": [
		"a154",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-1f61907e"
	],
	"./products/details/BloodPushing.vue": [
		"0330",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-5d3800ac"
	],
	"./products/details/DnaProd.vue": [
		"9dc0",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-4864a29e"
	],
	"./products/details/DnaReagent.vue": [
		"73ce",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-ebe87f0a"
	],
	"./products/details/Film.vue": [
		"3fe4",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-0d53af52"
	],
	"./products/details/Gemini.vue": [
		"4b9d",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-1f2a5862"
	],
	"./products/details/Marrow.vue": [
		"6b62",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-33e08b02"
	],
	"./products/details/Patholog.vue": [
		"6656",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-0cf73540"
	],
	"./products/details/Pelleter.vue": [
		"3d83",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-37b8dc24"
	],
	"./products/details/Special.vue": [
		"3f22",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-1b1a33a8"
	],
	"./products/details/TctProd-备份.vue": [
		"7daf",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-41a0eec2"
	],
	"./products/details/TctProd.vue": [
		"4e3d",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-23ae154c",
		"chunk-5a53e4f2"
	],
	"./products/details/TctReagent.vue": [
		"6900",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-14380d24"
	],
	"./science/DecipherDetail.vue": [
		"60c6",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-5fc8a71c"
	],
	"./science/DoctorDetail.vue": [
		"dae5",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-2d21d0c2",
		"chunk-0a1356a8"
	],
	"./science/Science.vue": [
		"f3ca",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-076da0db"
	],
	"./science/SubView.vue": [
		"4a91",
		"chunk-3bd28135"
	],
	"./science/components/Decipher.vue": [
		"fe47",
		"chunk-6ffb7b8c",
		"chunk-950ca1a2"
	],
	"./science/components/Doctor.vue": [
		"3db4",
		"chunk-6ffb7b8c",
		"chunk-17d24801"
	],
	"./solution/Solution.vue": [
		"cc0b",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-6941983a"
	],
	"./solution/SubView.vue": [
		"41b4",
		"chunk-6a7b4e6e"
	],
	"./solution/componets/RelatedProduct.vue": [
		"aaad",
		"chunk-7992b2a5"
	],
	"./solution/details/Blood.vue": [
		"9694",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-49c04cac"
	],
	"./solution/details/Dna.vue": [
		"6c59",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-ce7c6102"
	],
	"./solution/details/Tbs.vue": [
		"04e8",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-74b30ddc"
	],
	"./solution/details/Telepathology.vue": [
		"2368",
		"chunk-6ffb7b8c",
		"chunk-4141b6e8",
		"chunk-f5474d80"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "94b3";
module.exports = webpackAsyncContext;